import React from "react";

import { useTranslation } from "react-i18next";

import CarouselRowSelector from "./CarouselRowSelector";
import ImageFormatSelector from "./ImageFormatSelector";

import type { JSX } from "react";

import type { CarouselRow } from "../../../constants/carouselRow";
import type { ImageFormat } from "../../../constants/ratio";

interface FormatSelectorProps {
  onChange: (options: { ratio?: ImageFormat; row?: CarouselRow }) => void;
  imageFormatList: ImageFormat[];
  ratio: ImageFormat;
  isCarousel: boolean;
  carouselRow?: CarouselRow;
}

function FormatSelector({
  onChange,
  isCarousel,
  imageFormatList,
  ratio,
  carouselRow,
}: FormatSelectorProps): JSX.Element {
  const { t } = useTranslation("editor-platform");

  const isHorizontalRatio =
    ratio === "163" || ratio === "166" || ratio === "169";

  const hasCarouselRowSelector = isCarousel && isHorizontalRatio;

  const handleChangeImageFormat = (newRatio: ImageFormat): void => {
    const isHorizontalUpdatedRatio =
      newRatio === "163" || newRatio === "166" || newRatio === "169";

    if (isCarousel) {
      if (!isHorizontalUpdatedRatio) {
        onChange({
          ratio: newRatio,
          row: undefined,
        });

        return;
      }

      if (isHorizontalUpdatedRatio && !carouselRow) {
        onChange({
          ratio: newRatio,
          row: "single",
        });

        return;
      }
    }

    onChange({
      ratio: newRatio,
    });
  };

  return (
    <div className="flex flex-col gap-[0.625rem] pb-[0.625rem]">
      <ImageFormatSelector
        imageFormatList={imageFormatList}
        onChangeRatio={handleChangeImageFormat}
        selected={ratio}
        title={t("pictureRatio")}
      />
      {hasCarouselRowSelector ? (
        <CarouselRowSelector
          onClick={(row): void => onChange({ row })}
          ratio={ratio}
          selected={carouselRow}
        />
      ) : null}
    </div>
  );
}

export default FormatSelector;
